module.exports = __webpack_public_path__ + "ad22b91f9fca1257b75518d11ef36d52.png";